import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFeedbackIntroIllustration = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: 124,
	viewBox: "0 0 520 124",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	role: "img",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 519,
			height: 123,
			rx: 10,
			fill: "#f6f7fc",
			stroke: "#e7e9f5"
		}),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#e7e9f5",
			children: [
				/* @__PURE__ */ _jsx("line", {
					x1: 0,
					y1: 31,
					x2: 520,
					y2: 31
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: 0,
					y1: 62,
					x2: 520,
					y2: 62
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: 0,
					y1: 93,
					x2: 520,
					y2: 93
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 60,
				y: 74,
				width: 34,
				height: 34,
				rx: 4,
				fill: "#c7cdf3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 120,
				y: 58,
				width: 34,
				height: 50,
				rx: 4,
				fill: "#aab2ef"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 180,
				y: 40,
				width: 34,
				height: 68,
				rx: 4,
				fill: "#8b96e8"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 240,
				y: 50,
				width: 34,
				height: 58,
				rx: 4,
				fill: "#6b7be0"
			})
		] }),
		/* @__PURE__ */ _jsx("polyline", {
			points: "320,86 360,70 400,76 440,46 480,40",
			stroke: "#6b7be0",
			strokeWidth: 3,
			fill: "none",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#6b7be0",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 320,
					cy: 86,
					r: 3.5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 360,
					cy: 70,
					r: 3.5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 400,
					cy: 76,
					r: 3.5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 440,
					cy: 46,
					r: 3.5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 480,
					cy: 40,
					r: 4.5,
					stroke: "#fff",
					strokeWidth: 2
				})
			]
		})
	]
});
export default SvgFeedbackIntroIllustration;
